import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ApiService<T> {
  constructor(
    private http: HttpClient,
    private hostUrl: string,
    private route: string
  ) {}

  get<T = any, U = T>(additionalUrl: string): Observable<U> {
    const url = this.addAdditionalUrl(additionalUrl);
    return this.http.get<U>(url).pipe(catchError(this.handleError));
  }

  post<T, U>(body: T, additionalUrl: string): Observable<U> {
    const url = this.addAdditionalUrl(additionalUrl);
    return this.http.post<U>(url, body).pipe(catchError(this.handleError));
  }

  put<T, U>(body: T, additionalUrl: string): Observable<U> {
    const url = this.addAdditionalUrl(additionalUrl);
    return this.http.put<U>(url, body).pipe(catchError(this.handleError));
  }

  patch<T, U>(body: T, additionalUrl: string): Observable<U> {
    const url = this.addAdditionalUrl(additionalUrl);
    return this.http.patch<U>(url, body).pipe(catchError(this.handleError));
  }

  delete<T, U>(additionalUrl: string, body?: T): Observable<U> {
    const url = this.addAdditionalUrl(additionalUrl);
    return this.http
      .delete<U>(url, body ? { body } : undefined)
      .pipe(catchError(this.handleError));
  }

  addAdditionalUrl(additionalUrl: string): string {
    const requestUrl = this.getRequestUrl();
    if (additionalUrl) {
      return `${requestUrl}${additionalUrl}`;
    }
    return requestUrl;
  }

  getRequestUrl(): string {
    return `${this.hostUrl}${this.route}`;
  }

  private handleError(error: HttpErrorResponse) {
    if (error.status === 0) {
      console.error('An error occurred:', error.error);
    } else {
      console.error(
        `Backend returned code ${error.status}, body was: `,
        error.error
      );
    }
    return throwError(
      () => new Error('Something bad happened; please try again later.')
    );
  }
}
